/**
 * Created by Bart Decorte
 * Date: 2019-07-16
 * Time: 10:24
 */
const EventEmitter = require('events');
import { evaluateCondition } from '../../../helpers/condition_helper';
import { columnByType } from '../../../helpers/column_helper';
import { isDirectChildOfClass } from '../../../helpers/dom_helper';

class EntriesDetail extends EventEmitter {
  constructor({ $root, dirtyUnloadNotifier, level = 0 }) {
    super();
    this.$root = $root;
    this.dirtyUnloadNotifier = dirtyUnloadNotifier;
    this.level = level;
    this.bindListeners();
    this.rerender();
    this.columns = this.initColumns();
    this.columnsBusyCount = 0;
  }

  bindListeners() {
    this.$root.on(
      'change',
      this.columnSelector() + ' .js-column-value',
      (ev) => {
        this.lColumnValueChanged(ev);
      }
    );
    $('.js-entry-select').on('click', (ev) => {
      ev.stopPropagation();
    });
  }

  lColumnValueChanged(ev) {
    const $elt = $(ev.target);
    if (isDirectChildOfClass($elt, this.$root, '.js-entries')) {
      this.rerender();
    }
  }

  columnSelector() {
    return '.js-column';
  }

  getColumns() {
    let $columns = this.$root.find(this.columnSelector());
    $columns = $columns.toArray().filter((column) => {
      return (
        isDirectChildOfClass($(column), this.$root, '.js-entries') &&
        $(column).parents('.js-dummy').length == 0
      );
    });
    return $columns;
  }

  rerender() {
    const $columns = this.getColumns();
    const values = this.values();

    for (let i = 0; i < $columns.length; i++) {
      let $column = $($columns[i]);
      let condition = this.condition($column);
      if (typeof condition === typeof undefined) {
        this.show($column, true);
      } else {
        this.show($column, evaluateCondition(condition, values));
      }
    }
  }

  condition($column) {
    const condition = $column.data('condition');
    return condition ? condition : undefined;
  }

  show($column, doShow = true) {
    const column = $column.get(0);
    column.style.setProperty(
      'display',
      doShow ? '' : 'none',
      doShow ? null : 'important'
    );
  }

  values() {
    const $columns = this.getColumns();
    const values = {};
    for (let i = 0; i < $columns.length; i++) {
      let $column = $($columns[i]);

      if (!$column.is('[data-column]')) {
        continue;
      }

      const $valueColumn = $column.find('.js-column-value');
      let value;
      if ($valueColumn.attr('type') === 'checkbox') {
        value = $valueColumn.is(':checked') ? 1 : 0;
      } else {
        value = $column.find('.js-column-value').val();
      }
      values[$column.data('column')] = value;
    }
    return values;
  }

  isDummy() {
    return this.$root.parents('.js-dummy').length > 0;
  }

  initColumns() {
    const columns = [];
    const $columns = this.getColumns();

    for (let i = 0; i < $columns.length; i++) {
      let $root = $($columns[i]);
      let type = $root.data('column-type');
      let className = columnByType(type);
      if (typeof className !== typeof undefined) {
        let column = new className({
          $root,
          dirtyUnloadNotifier: this.dirtyUnloadNotifier,
          level: this.level,
        });
        column.on('busy', () => {
          this.incrementColumnsBusyCount();
        });
        column.on('idle', () => {
          this.incrementColumnsBusyCount(false);
        });
        columns.push(column);
      }
    }

    return columns;
  }

  startSorting() {
    for (let i = 0; i < this.columns.length; i++) {
      this.columns[i].startSorting();
    }
    return this;
  }

  stopSorting() {
    for (let i = 0; i < this.columns.length; i++) {
      this.columns[i].stopSorting();
    }
    return this;
  }

  isIdle() {
    return this.columnsBusyCount < 1;
  }

  incrementColumnsBusyCount(doIncrement = true) {
    const initialValue = this.columnsBusyCount;
    this.columnsBusyCount += doIncrement ? 1 : -1;

    if (initialValue > 0 && this.columnsBusyCount < 1) {
      this.emit('idle');
    } else if (initialValue < 1 && this.columnsBusyCount > 0) {
      this.emit('busy');
    }
  }
}

export default EntriesDetail;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Entries/_partials/EntriesDetail.js